import React from 'react';
import { Placeholder } from 'react-bootstrap';

const MESSAGES = [
    { isMine: false, width: '70%' },
    { isMine: true, width: '55%' },
    { isMine: false, width: '62%' },
];

export function MessageListSkeleton({ count = 3 }: { count?: number }) {
    const messages = Array.from({ length: count }).map((_, i) => MESSAGES[i % MESSAGES.length]);

    return (
        <Placeholder as="div" animation="glow" aria-hidden="true">
            {messages.map(({ isMine, width }, i) => (
                <div key={i} className="mt-3 pb-3 d-flex align-items-start">
                    {!isMine && <Placeholder className="skeleton skeleton-message-avatar mr-3" />}
                    <div className={`d-flex w-100 flex-column ${isMine ? 'align-items-end' : 'align-items-start'}`}>
                        <Placeholder className={`skeleton skeleton-message-meta ${isMine ? 'mb-2' : 'mb-1'}`} />
                        <Placeholder className="skeleton skeleton-message-bubble" style={{ width }} />
                    </div>
                </div>
            ))}
        </Placeholder>
    );
}
